import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const HeroSection = () => {
  const handleWhatsAppClick = () => {
    if (typeof (window as Window & { gtag?: (...args: unknown[]) => void }).gtag === 'function') {
      (window as Window & { gtag: (...args: unknown[]) => void }).gtag('event', 'conversion', {
        send_to: 'AW-17106059641/wLJKCOOCiIscEPmC59w_',
        value: 1.0,
        currency: 'CLP',
      });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-black via-gray-900 to-black overflow-hidden pt-20">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/ec4a64a7c95841143717a31d0b240e93.jpg"
          alt="Bala Corp Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/70"></div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute top-20 left-10 w-32 h-32 bg-primary-yellow/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 right-10 w-40 h-40 bg-primary-yellow/10 rounded-full blur-3xl"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 py-10 pb-24">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Column - Content */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center lg:text-left"
          >
            <motion.h1
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2, duration: 0.8 }}
              className="text-5xl lg:text-6xl xl:text-7xl font-extrabold text-white leading-tight mb-6"
            >
              Posesión efectiva
              <br />
              <span className="text-primary-yellow">de herencia en Chile</span>
              <br />
              <span className="text-4xl lg:text-5xl xl:text-6xl">sin complicaciones</span>
            </motion.h1>

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.4, duration: 0.8 }}
              className="text-xl text-gray-300 mb-6 leading-relaxed"
            >
              Gestionamos todo el trámite de posesión efectiva de forma completa, clara y con acompañamiento profesional en cada etapa.
            </motion.p>

            {/* Key benefits bullets */}
            <motion.ul
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.5, duration: 0.8 }}
              className="space-y-2 mb-8 text-left max-w-xl mx-auto lg:mx-0"
            >
              {[
                'Proceso 100% online, sin salir de casa',
                'Nos encargamos de recopilar los antecedentes',
                'Seguimiento completo hasta el cierre del trámite',
                'Asesoría profesional incluida en cada caso',
              ].map((item, i) => (
                <li key={i} className="flex items-center space-x-3">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                    <i className="ri-checkbox-circle-fill text-primary-yellow text-lg"></i>
                  </div>
                  <span className="text-gray-200 text-base">{item}</span>
                </li>
              ))}
            </motion.ul>

            {/* CTA Buttons Grid */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.8, duration: 0.8 }}
              className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-xl mx-auto lg:mx-0"
            >
              <Link
                to="/posesion-efectiva"
                className="bg-primary-yellow text-black px-8 py-4 rounded-lg font-semibold hover:bg-yellow-400 transition-all duration-300 hover:shadow-lg hover:shadow-yellow-500/50 text-center whitespace-nowrap cursor-pointer"
              >
                Posesión efectiva
              </Link>
              <Link
                to="/servicios"
                className="bg-primary-yellow text-black px-8 py-4 rounded-lg font-semibold hover:bg-yellow-400 transition-all duration-300 hover:shadow-lg hover:shadow-yellow-500/50 text-center whitespace-nowrap cursor-pointer"
              >
                Crear empresa
              </Link>
              <Link
                to="/servicios"
                className="bg-primary-yellow text-black px-8 py-4 rounded-lg font-semibold hover:bg-yellow-400 transition-all duration-300 hover:shadow-lg hover:shadow-yellow-500/50 text-center whitespace-nowrap cursor-pointer"
              >
                Registrar marca
              </Link>
              <a
                href="https://wa.me/56912345678"
                target="_blank"
                rel="nofollow noopener noreferrer"
                onClick={handleWhatsAppClick}
                className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-lg font-semibold hover:bg-white hover:text-black transition-all duration-300 flex items-center justify-center space-x-2 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-fill text-xl text-green-500"></i>
                <span>Contactar por WhatsApp</span>
              </a>
            </motion.div>
          </motion.div>

          {/* Right Column - Illustration */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.4, duration: 0.8 }}
            className="hidden lg:flex flex-col items-center justify-center relative"
          >
            {/* Main Image */}
            <div className="relative w-full h-[520px] rounded-2xl overflow-hidden shadow-2xl shadow-yellow-500/20 border border-white/10">
              <img
                src="https://public.readdy.ai/ai/img_res/edited_f73dc4b67fb55086996ec022b054adab_170bc9e7.jpg"
                alt="Servicios Legales Ilustración"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
            </div>

            {/* Floating Card - Top Left */}
            <motion.div
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.9, duration: 0.6 }}
              className="absolute -top-4 -left-6 bg-white rounded-xl px-4 py-3 shadow-xl flex items-center space-x-3"
            >
              <div className="w-9 h-9 flex items-center justify-center bg-primary-yellow rounded-full">
                <i className="ri-file-search-fill text-black text-base"></i>
              </div>
              <div>
                <p className="text-xs text-gray-500 leading-none">Cada caso</p>
                <p className="text-sm font-extrabold text-black leading-tight whitespace-nowrap">Revisión profesional</p>
              </div>
            </motion.div>

            {/* Floating Card - Bottom Right */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 1.1, duration: 0.6 }}
              className="absolute -bottom-4 -right-6 bg-white rounded-xl px-4 py-3 shadow-xl flex items-center space-x-3"
            >
              <div className="w-9 h-9 flex items-center justify-center bg-primary-yellow rounded-full">
                <i className="ri-route-fill text-black text-base"></i>
              </div>
              <div>
                <p className="text-xs text-gray-500 leading-none">En todo momento</p>
                <p className="text-sm font-extrabold text-black leading-tight whitespace-nowrap">Seguimiento del proceso</p>
              </div>
            </motion.div>

            {/* Floating Badge - Bottom Left */}
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 1.3, duration: 0.6 }}
              className="absolute bottom-10 -left-6 bg-black border border-primary-yellow/40 rounded-xl px-4 py-3 shadow-xl flex items-center space-x-2"
            >
              <i className="ri-scales-3-fill text-primary-yellow text-lg"></i>
              <p className="text-white text-sm font-semibold whitespace-nowrap">Gestión legal completa</p>
            </motion.div>
          </motion.div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.2, duration: 0.8 }}
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-0 pointer-events-none"
      >
        <div className="hidden sm:flex flex-col items-center space-y-2">
          <span className="text-white text-xs uppercase tracking-wider">Descubre más</span>
          <motion.div
            animate={{ y: [0, 10, 0] }}
            transition={{ repeat: Infinity, duration: 1.5 }}
            className="w-6 h-10 border-2 border-primary-yellow rounded-full flex items-start justify-center p-2"
          >
            <div className="w-1 h-2 bg-primary-yellow rounded-full"></div>
          </motion.div>
        </div>
      </motion.div>
    </section>
  );
};

export default HeroSection;